import React from 'react';

const ChevronDownIcon = (props) => (
    <svg
        fill="#ffffff"
        viewBox="0 0 56 56"
        {...props}
    >
        < path d="M 27.9999 51.9063 C 41.0546 51.9063 51.9063 41.0781 51.9063 28 C 51.9063 14.9453 41.0312 4.0937 27.9765 4.0937 C 14.8983 4.0937 4.0937 14.9453 4.0937 28 C 4.0937 41.0781 14.9218 51.9063 27.9999 51.9063 Z M 27.9999 47.9219 C 16.9374 47.9219 8.1014 39.0625 8.1014 28 C 8.1014 16.9609 16.9140 8.0781 27.9765 8.0781 C 39.0155 8.0781 47.8983 16.9609 47.9219 28 C 47.9454 39.0625 39.0390 47.9219 27.9999 47.9219 Z M 30.3202 34.8437 L 39.5077 25.0703 C 40.2109 24.3437 40.2343 23.2422 39.5780 22.6094 C 38.8749 21.8594 37.7265 21.8359 37.0702 22.5625 L 27.9999 32.1719 L 18.9296 22.5625 C 18.2499 21.8359 17.1014 21.8594 16.3983 22.6094 C 15.7421 23.2422 15.7890 24.3437 16.4687 25.0703 L 25.6796 34.8437 C 27.1327 36.3906 28.8436 36.3906 30.3202 34.8437 Z" />
    </svg>
);
export default ChevronDownIcon;